/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type Bdkv2UnaryOperator =
  (typeof Bdkv2UnaryOperator)[keyof typeof Bdkv2UnaryOperator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bdkv2UnaryOperator = {
  UnaryOperatorNot: 'UnaryOperatorNot',
  UnaryOperatorExists: 'UnaryOperatorExists',
} as const;
